import FieldsModel from '@/Models/Contracts/FieldsModel';
import i18n from '@/Plugins/i18n';
export default class Projection extends FieldsModel {
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    constructor(...props) {
        super(...props);
        this.type = 'projection';
    }
    getType() {
        return 'projection';
    }
    get header() {
        return `
            <span class="grid gap-2">
                <span>${i18n.t('general.projection')}</span>
                <span>${moment(this.date).format('MMMM YYYY')}</span>
            </span>
        `;
    }
}
